import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=d2291e22&scoped=true&"
import script from "./ChatForm.vue?vue&type=script&lang=js&"
export * from "./ChatForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=d2291e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2291e22",
  null
  
)

export default component.exports